<template>
  <el-dialog :title="!dataForm.menuId ? '新增' : '修改'" :modal-append-to-body="false" :show-close="false"
    :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
      label-width="80px">
      <el-form-item label="上级菜单">
        <el-input v-model="dataForm.parentId" placeholder="上级菜单ID"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="menuName">
        <el-input v-model="dataForm.menuName" placeholder="菜单/按钮名称"></el-input>
      </el-form-item>
      <el-form-item label="URL">
        <el-input v-model="dataForm.url" placeholder="菜单URL"></el-input>
      </el-form-item>
      <el-form-item label="权限标识">
        <el-input v-model="dataForm.perms" placeholder="权限标识"></el-input>
      </el-form-item>
      <el-form-item label="图标">
        <el-input v-model="dataForm.icon" placeholder="图标"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="dataForm.type" placeholder="请选择类型" style="width: 100%"
          :disabled="dataForm.menuId ? true : false">
          <el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="dataForm.orderNum" placeholder="排序"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      typeOption: [{
        label: '菜单',
        value: "0",
      }, {
        label: '按钮',
        value: "1",
      }],
      dataForm: {
        menuId: 0,
        parentId: 0,
        menuName: '',
        url: '',
        perms: '',
        icon: '',
        type: "0",
        orderNum: '',
        createTime: '',
        modifyTime: '',
      },
      dataRule: {
        menuName: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init(row) {
      this.visible = true
      if (row) {
        if (row.data) {
          this.dataForm.menuId = row.data.menuId
          this.dataForm = row.data
        } else {
          //只传了菜单id，作为要创建菜单的父级id
          this.dataForm = {}
          this.dataForm.parentId = row
        }
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/menu/${!this.dataForm.menuId ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'menuId': this.dataForm.menuId || null,
              'parentId': this.dataForm.parentId,
              'menuName': this.dataForm.menuName,
              'url': this.dataForm.url,
              'perms': this.dataForm.perms,
              'icon': this.dataForm.icon,
              'type': this.dataForm.type,
              'orderNum': this.dataForm.orderNum,
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/parameters/menu-add-or-update.vue